"use client";

import dynamic from "next/dynamic";

const LanguageSelect = dynamic(() => import("../header/languages"), {
  ssr: false,
  loading: () => <div className="w-20 h-8 rounded bg-white/10 animate-pulse" />,
});

export default function LanguageSelectClient() {
  return <LanguageSelect />;
}